import styled from 'styled-components';

const Card = styled.div`
  background-color: ${({theme}) => theme.white};
  overflow: hidden;
  flex: 1;
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
  height: calc(100% - ${({theme}) => theme.spacingVertical(2)});
  margin: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
  display: flex;
  flex-direction: column;
`;

export default Card;
